import React from "react";
import { dispatch } from '@rematch/core';
import EventStreamContent from './../../home/DesignerPane/EventStreamContent'
import { Grid, Card, Label } from "semantic-ui-react";
import CounterCard from './../drive/cards/CounterCard';
import OrganizationRecentUpdates from "../drive/cards/OrganizationRecentUpdates";
import BreadCrumbOrganization from "../drive/cards/BreadCrumbOrganization";
import EventDetailsNotFound from './../../home/Drive/Modal/EventDetailsNotFound';

class OrganizationEvents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingData: true,
    }
  }



  componentWillMount() {
    dispatch.app.showToolbar(false)
    dispatch.community.addMainAreaContext('Events');
    dispatch.users.storeUnitId(this.props.selectedOrganisation.id);
    dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    dispatch.organizationUnit.showResourecePane(null);
    dispatch.app.showTeamListView(true);
    if (this.props.selectedOrganisation && this.props.selectedOrganisation.role === 'workspaceOwner') {
      dispatch.organizationUnit.getOrganizationCount({ organizationId: this.props.match.params.workspaceId, accountId: this.props.match.params.accountId })
    }
    else if (this.props.selectedOrganisation && this.props.selectedOrganisation.role === 'Manager') {
      dispatch.organizationUnit.myCommunityDashboardCount({ organizationId: this.props.match.params.workspaceId, accountId: this.props.match.params.accountId })
    }
    let payL = {
      limit: 10,
      type: "all",
      role: this.props.selectedOrganisation.role
    }
    dispatch.notifications.getEventStreamForCommunity(payL);
    dispatch.notifications.getEventStreamCount({ role: this.props.selectedOrganisation.role });
    dispatch.notifications.getRecentUpdates({ limit: 20, role: this.props.selectedOrganisation.role });
  }

  render() {
    let allOrgUsers=this.props.executiveList.length+this.props.managerList.length+this.props.memberList.length
    return (
      <div>
        <BreadCrumbOrganization {...this.props} />
        <Grid>
          <Grid.Row className="pad_0">
            <Grid.Column width={11} style={{ padding: "1px 5px 0px 2px" }} >
              <Card className="w_100">
                <Card.Header ></Card.Header>
                <Card.Content className="pad_0" style={{ borderWidth: '0px' }} >
                  <EventStreamContent
                    eventPage="organization"
                    loaderEventData={this.props.loaderEventStreamForCommunity}
                    eventStreamArray={this.props.eventStreamArrayForCommunity}
                    selectedOrganisation={this.props.selectedOrganisation}
                    notificationsCount={this.props.notificationsCount}
                    selectedAccount={this.props.selectedAccount}
                    initiativeOwnerDetails={this.props.initiativeOwnerDetails}
                    eventStreamCount={this.props.eventStreamCount}
                    noEventDataFound={this.props.noEventDataFound}
                    currentOrganization={this.props.currentOrganization}
                    user={this.props.user}
                  />
                </Card.Content>
              </Card>
            </Grid.Column>
            <Grid.Column width={5} style={{ padding: "0 5px" }}>
              <CounterCard
                allOrgUsers={allOrgUsers}
                organizationCountData={this.props.organizationCountData}
                selectedOrganisation={this.props.selectedOrganisation}
                selectedAccount={this.props.selectedAccount}
                history={this.props.history}
                isLoadingData={this.state.isLoadingData}
                user={this.props.user}
                loadingOrganization={this.props.loadingOrganization}
                loadingMyOrganization={this.props.loadingMyOrganization}

              />
              <Card className="w_100" style={{ margin: "10px 0 0 0" }}>
                <Card.Header className="pad_10">Recent Updates <Label size="small" >{this.props.recentUpdates.total}  </Label> </Card.Header>
                <Card.Content className="pad_0" >
                  <OrganizationRecentUpdates
                    eventPage="organization"
                    recentUpdates={this.props.recentUpdates}
                    loaderRecentUpdates={this.props.loaderRecentUpdates}
                    selectedOrganisation={this.props.selectedOrganisation}
                  />
                </Card.Content>
              </Card>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <EventDetailsNotFound
          open={this.props.noEventDataFound}
        />

      </div>
    );
  }
}
export default OrganizationEvents;
